'use client';

import React from 'react';
import { Box, Flex, Skeleton } from '@skin-seoul/design-system';
const TestimonialCardSkeleton = () => {
  return <Flex flexDirection="column" width="100%" borderRadius="16px" padding={4} gap={4} backgroundColor="neutral.50" height="100%" data-sentry-element="Flex" data-sentry-component="TestimonialCardSkeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
      {/* Image skeleton */}
      <Skeleton width="100%" height="272px" minHeight="272px" borderRadius="24px" data-sentry-element="Skeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />

      {/* Rating and date skeleton */}
      <Flex gap={4} alignItems="center" width="100%" backgroundColor="generic.0" paddingX={4} paddingY={2} borderRadius="26px" justifyContent="space-between" data-sentry-element="Flex" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
        <Flex gap={1} alignItems="center" data-sentry-element="Flex" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
          <Skeleton height="24px" width="24px" borderRadius="4px" data-sentry-element="Skeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />
          <Skeleton height="20px" width="20px" borderRadius="4px" data-sentry-element="Skeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />
        </Flex>
        <Skeleton height="16px" width="80px" borderRadius="4px" data-sentry-element="Skeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />
      </Flex>

      {/* Title and review content skeleton */}
      <Flex flexDirection="column" gap={4} width="100%" alignItems="flex-start" data-sentry-element="Flex" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
        <Flex flexDirection="column" gap={2} width="100%" alignItems="flex-start" data-sentry-element="Flex" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
          <Skeleton height="24px" width="70%" borderRadius="4px" data-sentry-element="Skeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />
          <Flex gap={1} alignItems="flex-start" height="48px" width="100%" data-sentry-element="Flex" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
            <Skeleton height="40px" width="100%" borderRadius="4px" data-sentry-element="Skeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />
          </Flex>
        </Flex>
        <Flex gap={1} alignItems="center" data-sentry-element="Flex" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
          <Skeleton height="16px" width="60px" borderRadius="4px" data-sentry-element="Skeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />
          <Skeleton height="16px" width="80px" borderRadius="4px" data-sentry-element="Skeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />
        </Flex>
      </Flex>

      {/* Product info skeleton */}
      <Flex gap={2} padding={2} backgroundColor="generic.0" borderRadius="16px" alignItems="center" width="100%" data-sentry-element="Flex" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
        <Skeleton width="60px" height="60px" borderRadius="8px" data-sentry-element="Skeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />
        <Flex flexDirection="column" gap={2} alignItems="flex-start" data-sentry-element="Flex" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
          <Skeleton height="16px" width="80px" borderRadius="4px" data-sentry-element="Skeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />
          <Skeleton height="14px" width="120px" borderRadius="4px" data-sentry-element="Skeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />
        </Flex>
      </Flex>
    </Flex>;
};
const CustomerTestimonialsSwiperSkeleton = () => {
  return <Box width="100%" position="relative" data-sentry-element="Box" data-sentry-component="CustomerTestimonialsSwiperSkeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
      {/* Cards container */}
      <Flex width="100%" justifyContent="space-between" gap={{
      base: 4,
      tablet: 6
    }} data-sentry-element="Flex" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
        <Box width="100%" position="relative" data-sentry-element="Box" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
          <TestimonialCardSkeleton data-sentry-element="TestimonialCardSkeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />

          <Box position="absolute" top="15%" right="-13px" height="70%" width="1px" backgroundColor="neutral.10" display={{
          base: 'none',
          tablet: 'block'
        }} zIndex={1} data-sentry-element="Box" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />
        </Box>

        <Box width="100%" display={{
        base: 'none',
        tablet: 'block'
      }} position="relative" data-sentry-element="Box" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
          <TestimonialCardSkeleton data-sentry-element="TestimonialCardSkeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />

          <Box position="absolute" top="15%" right="-13px" height="70%" width="1px" backgroundColor="neutral.10" display={{
          base: 'none',
          desktop: 'block'
        }} zIndex={1} data-sentry-element="Box" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />
        </Box>

        <Box width="100%" display={{
        base: 'none',
        desktop: 'block'
      }} data-sentry-element="Box" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
          <TestimonialCardSkeleton data-sentry-element="TestimonialCardSkeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />
        </Box>
      </Flex>

      <Flex alignItems="center" gap={6} justifyContent="center" width="100%" marginTop={6} data-sentry-element="Flex" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
        <Skeleton height="36px" width="36px" borderRadius="full" data-sentry-element="Skeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />

        <Flex alignItems="center" gap={1} data-sentry-element="Flex" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx">
          {[...Array(5)].map((_, idx) => <Skeleton key={idx} height="4px" width={idx === 0 ? '32px' : '8px'} borderRadius={idx === 0 ? '4px' : 'full'} />)}
        </Flex>

        <Skeleton height="36px" width="36px" borderRadius="full" data-sentry-element="Skeleton" data-sentry-source-file="CustomerTestimonialsSwiperSkeleton.tsx" />
      </Flex>
    </Box>;
};
export default CustomerTestimonialsSwiperSkeleton;